module.exports = {
};



//////////////////
// WEBPACK FOOTER
// ./cfg/game-config.js
// module id = 32
// module chunks = 0